import React from 'react';
import { useLocation } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import QrLiveDeviceListPage from '@modules/restaurant/Devices/tabs/qrlive';
import routes from '@routes';

const QrliveDeviceDetailPage = () => {
    const translate = useTranslate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const restaurantId = queryParams.get('restaurantId');
    const restaurantName = queryParams.get('restaurantName');
    const collapseId = queryParams.get('collapseId');
    const tabKey = queryParams.get('tab') || 'qrlive';

    return (
        <PageWrapper
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.qrLive),
                    path: collapseId 
                        ? `${routes.listQrliveDevicePage.path}?collapseId=${collapseId}` 
                        : routes.listQrliveDevicePage.path,
                },
                {
                    breadcrumbName: restaurantName,
                },
            ]}
        >
            <QrLiveDeviceListPage
                tabKey={tabKey}
                restaurantId={restaurantId}
                savedFilter={null}
                onFilterChange={() => {}}
            />
        </PageWrapper>
    );
};

export default QrliveDeviceDetailPage;